export enum RoleEnum {
    SuperAdministrator = "SuperAdministrator",
    Administrator = "Administrator",
    Driver = "Driver",
    Operations = "Operations",
    Editor = "Editor"
}

export enum PrintedDocumentTypeEnum {
    Barcode = 1,
    Certificate = 2,
    ControlSheet = 3,
    Delivery = 4,
    Envelope = 5,
    UrnLabel = 6
}
